import React, { Component } from 'react';
import './listview.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import * as repositoryActions from './../../../Store/Actions/repositoryActions';
import { CSVLink, CSVDownload } from "react-csv";
//import { layer } from '@fortawesome/fontawesome-svg-core';

//Component
import ToolStrip from '../ToolStrip/toolStrip';
import Button from '../Button/button';
import InfiniteScroll from 'react-infinite-scroll-component';

class ListView extends Component {
  constructor(props) {
    super(props);
    // PROPS
    /*
      --config={isSelectable:true/false,columns:[
          {name:"",type:""},
          {name:"",type:""}
        ]}
        listItem=[{},{}];
        //  isSelectable = 
        // 
      --selectedItems  //callbackMethod
    */
      this.state = {
          selectedItemIds:[],
          columns:[],
          items:[],
          term:"",
          mode:"",
          rightIsOpen:false,
          flagArchive:false,
          flagUnarchive:true,
          activeMode :"List",
          addAction:false,
          viewModes:[{name:"List",icon:"list"},{name:"Cards",icon:"th"}],
          toolstripConfig: [
            {name:"Add",isEnable:true, show:"hide", icon:"plus", endPoint:"EN3ECLoad"},
            {name:"Update",isEnable:true, show:"hide", icon:"pen", endPoint:"EN3ECLoad"},
            {name:"Archive",isEnable:true, show:"hide", icon:"box", endPoint:"EN3ECLoad"},
            {name:"Refresh",isEnable:true, show:"hide", icon:"sync-alt", endPoint:"EN3ECLoad"},
            {name:"Valid",isEnable:true, show:"hide", icon:"check", endPoint:"EN3ECLoad"},
            {name:"Cancel",isEnable:true, show:"hide", icon:"times", endPoint:"EN3ECLoad"},
          ],
      };

  }
  
  // INNER METHOD

  onTermUpdate = (clear,e) =>{
      this.setState({term:clear? "": e.target.value});
      //this.props.getDataSet(this.props.node,true,e.target.value);
  }

  toggleFlag = (archiveToggle) =>{
    if(archiveToggle){
      this.setState({flagArchive:!this.state.flagArchive});
    }else{
      this.setState({flagUnarchive:!this.state.flagUnarchive});
    }

  }

  selectItem = (id) =>{
    var ids = this.state.selectedItemIds;
    if(ids.filter(i=>i === id).length >0){
      ids.splice(ids.indexOf(id),1);
    }else{
      ids.push(id);
    }
    
    if(this.props.config.isSelectable){
      this.setState({selectedItemId:[...new Set(ids)]});
      this.props.onSelectItem([...new Set(ids)]);
    }

  }

  sortColumn = (id) =>{
    var columns = this.state.columns;
    var asc = true;
    columns = columns.map((column,i)=>{
      if(column.sort !== undefined && column.sort !== null){
        
        if(i === id){
          if(column.sort === "ASC"){
            column.sort = "DESC";
            asc = false;
          }else{
            column.sort = "ASC";
          }
        }else{
          column.sort = null;
        }

      }else{
        column.sort = null;
        if(i === id){
            column.sort = "ASC";
        }

      }
      return column;
    });
  
    var itemSorted = this.state.items;
    if(asc){
      itemSorted.sort((a, b) => (a[columns.filter((column,i)=> column.sort !== null)[0].name] > b[columns.filter((column,i)=> column.sort !== null)[0].name]) ? 1 : -1);
    }else{
      itemSorted.sort((a, b) => (a[columns.filter((column,i)=> column.sort !== null)[0].name] < b[columns.filter((column,i)=> column.sort !== null)[0].name]) ? 1 : -1);
    }

    this.setState({columns:columns,items:itemSorted});
  }
  
  onClickedToolStrip = (itemClicked,relatedObject) =>{
    // GET NAME
    var action = itemClicked.name;
    
    this.props.toolbarReturn({action:action,object:relatedObject,config:this.props.config});
    
  }

  switchTab = (name) =>{
    this.setState({activeMode:name,mode:"EDIT"});
  }
  closeRightPart = ()=>{
    this.setState({rightIsOpen:false,mode:"READ"});
  }
  onSelectListItem = ()=>{

  }
  onClickEdit = (item) =>{
    console.log("EDIT");
    this.onClickedToolStrip({name:"Update"},item);
  }
  onClickAdd = () =>{
    var action = "Add";
    this.props.toolbarReturn({action:action,object:null,config:this.props.config});
    
  }

  onClickUnarchive = (item) =>{
    var action = "Unarchive";
    this.props.toolbarReturn({action:action,object:item,config:this.props.config});  
  }

  // BUILDING METHOD
  componentDidMount = () =>{
    //ENABLE ACTIONS
    var actions = [];
    var actionState = {};
    var columns = [];
    var addAction = false;

    if(this.props.config !== undefined){
      actions = this.props.config.actions;
      columns = this.props.config.columns;
    }
    actionState = this.state.toolstripConfig;
    
    if (actions !== undefined && actions.length>0){
      actions.map((action,i)=>{
     
        if(action==="Add"){
          addAction = true;
        }else{
          if(actionState.find(item=>item.name ===action) !== undefined ){
            actionState.find(item=>item.name ===action).show = "show";
          }
          
        }
        return null;
      });
    }
    //RESET PAGINATION
    console.log("reset pagination LISTVIEW");
    this.props.resetPagination();
    

    
   
    this.setState({items:this.props.listItem,columns:columns,toolstripConfig:actionState,addAction:addAction});
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.config !== undefined){
      this.setState({selectedItemIds:[],columns:nextProps.config.columns});
    }
      
  }


  buildHeaderContent = ()=>{
    var columns = this.state.columns;
    var ths = null;
    if(columns !== undefined){
      ths = columns.map((column,i)=>{
        var icon = null;
        if(column.sort !== undefined && column.sort !== null){
          icon = column.sort === "ASC"? <FontAwesomeIcon icon="sort-amount-down-alt"/>: <FontAwesomeIcon icon="sort-amount-down"/>;
        }
        return <th key={i} className={column.type} onClick={this.sortColumn.bind(this,i)}><div className="thWrapper"><div>{column.displayName}</div>{icon}</div></th>
      });
    
    ths.push(
    <th key={columns.length}>
      <span>Actions </span>   
    </th>
    );
    ths.unshift(
      <th key="status" className="status">
        <span> </span>   
      </th>
      );
    }
    return(<thead>
      <tr>
        {ths}
      </tr>
    </thead>)
  }

  buildModeSelector = () =>{
    var term = this.state.term;
    var flagArchive = this.state.flagArchive;
    var flagUnarchive = this.state.flagUnarchive;
    var columns = this.props.config.columns;
    if(this.state.viewModes !== null) 
    {
      var activeTab = this.state.activeMode;
      var content = this.state.viewModes.map((tab,key) => {
          return ( <div key={key} className={tab.name ===activeTab? "view-action active" :"view-action"} onClick={this.switchTab.bind(this,tab.name)}>
            <span>{tab.icon != null ?<FontAwesomeIcon  icon={tab.icon} />:null}</span>
          </div>) 
      });
      var data = this.props.listItem.filter(item=>flagArchive?item.FLAG === 255:true).filter(item=>flagUnarchive?item.FLAG < 255:true).filter(item=>{
        let pattern = new RegExp(term.toUpperCase());
        return JSON.stringify(item).toUpperCase().match(pattern);
      }).map((item,i)=>{
        var formatedItem = {};
        if(columns !== undefined){
          columns.map((column,j)=>{
            formatedItem[column.name] = item[column.name];
          });
        };
        return formatedItem;
      });
      content.push(<div className="view-action" key="csv">
                      <CSVLink data={data} target="_blank" filename={"csv_download.csv"}>
                        <FontAwesomeIcon  icon="download" />
                      </CSVLink>
                    </div>);
      return content;
    }else{
      return null
    }

  }
  

  buildListContent = (items)=>{
    var tds = [];
    var trs = null;
    var columns = this.props.config.columns;
    var config = this.props.config;
    var selecteds = this.state.selectedItemIds;
    
    var toolstripConfig = this.state.toolstripConfig;
    var language = this.props.language;
    var term = this.state.term;
    var flagArchive = this.state.flagArchive;
    var flagUnarchive = this.state.flagUnarchive;
    

  if(this.props.config !== undefined){
    
    if(items.length>0){
      trs = items.filter(item=>flagArchive?item.FLAG === 255:true).filter(item=>flagUnarchive?item.FLAG < 255:true).filter(item=>{
        let pattern = new RegExp(term.toUpperCase());
        return JSON.stringify(item).toUpperCase().match(pattern);
      }).map((item,i)=>{
        var itemSelected=false;
        if(columns !== undefined){
          tds = columns.map((column,j)=>{
            var tdValue = null;
          if(typeof item[column.name] !== "object"){
            tdValue = item[column.name];
          }else{
            tdValue = item[column.name][language];
          }


          return <td key={j} className={"param " +column.type} title={column.name}>
              <div className="param-key">{column.name}</div>
              <div className="param-value" title={column.name+": "+item[column.name]}>{tdValue}</div>
            </td>
          });
        }
        tds.push(
          <td key="action" className="actions" title={item.FLAG === 255 ? "Archived":"Active"}>
            {
              item.FLAG === 255?
              <Button 
                preventMultipleClick={500} 
                config={
                  {
                    isEnabled:true,
                    icon:"box-open",
                    text:"unarchive",
                    color:"#fff",
                    textAlign:"center",
                    bgcolor:"#5d65a4"
                  }
                } 
                OnClickElement={this.onClickUnarchive.bind(this,item)}
              />
              :
              <ToolStrip preventMultipleClick={500} object={item} config={toolstripConfig} OnClickElement={this.onClickedToolStrip.bind()}/>
            }
            </td>
        );
        tds.unshift(
          <td key={"status-"+i} className={"status flag-"+item.FLAG}>
            {item.FLAG ===255?
              <FontAwesomeIcon icon="box" title="archived"/>
              :
              <FontAwesomeIcon icon="box-open" title="unarchived"/>
            }
          </td>
        );
            
        if(selecteds.filter(id=>id === item[config.id]).length > 0){
          itemSelected = true;
        }else{
          itemSelected = false;
        }
        if(config.editable){
          return(<tr key={item[config.id]} onDoubleClick={this.onClickEdit.bind(this, item)} className={"flag-"+item.FLAG}>{tds}</tr>);
        }else{
          return(<tr key={item[config.id]} onClick={this.selectItem.bind(this, item[config.id])} className={config.isSelectable? (itemSelected?"selectable active flag-":"selectable flag-")+item.FLAG:(itemSelected?"active flag-":"flag-")+item.FLAG}>{tds}</tr>);
        
        }
        
      });
    }
    if(this.state.addAction){
      var addBtn = <td colSpan={columns.length+2}>
        <Button 
          preventMultipleClick={0} 
          config={
            {
              isEnabled:true,
              icon:"plus-square",
              text:"Add Item",
              color:"#fff",
              textAlign:"center",
              bgcolor:"#5d65a4"
            }
          } 
          OnClickElement={this.onClickAdd.bind(this)}
        />
      </td>;

      trs.push(
        <tr key="addButtonPost" className="">{addBtn}</tr>
      );
    } 
    
  }
    return(
      
      <tbody>
     
        {trs}
      
    </tbody>
    )
  }
  
  render() {
      var items = this.props.listItem;
      var node = this.props.node;
      var buildList = null;
      if(this.props.config !== undefined){
        buildList = this.buildListContent(items);
      }
      var buildHeader = this.buildHeaderContent();
      var modeSelector = this.buildModeSelector();


      return (
          <div className="listview-wrapper" >
              <div className="listview-header">
                <div className="searchbar" >
                  <input type="text" value={this.state.term} onChange={this.onTermUpdate.bind(this,false)}/>
                  <FontAwesomeIcon onClick={this.onTermUpdate.bind(this,true)} icon={this.state.term.length > 0?"times":"search"}/>
                </div>
                {modeSelector}
              </div>
              <div className="listview-menu">
                <div className="label-filter">Filters:</div>
                <div className="tags">
                  <div className={"active-"+this.state.flagArchive}>
                    <FontAwesomeIcon onClick={this.toggleFlag.bind(this,true)} icon="box-open"/>
                  </div>
                  <div className={"active-"+this.state.flagUnarchive}>
                    <FontAwesomeIcon onClick={this.toggleFlag.bind(this,false)} icon="box"/>
                  </div>
                </div>
                {
                this.state.addAction?
                  <Button 
                      preventMultipleClick={0} 
                      config={
                        {
                          isEnabled:true,
                          icon:"plus-square",
                          text:"Add Item",
                          color:"#fff",
                          textAlign:"center",
                          bgcolor:"#5d65a4"
                        }
                      } 
                      OnClickElement={this.onClickAdd.bind(this)}
                  />
                :
                  null
                }
                
              </div>
              <div className={"listview-content mode-"+this.state.activeMode}>
                <div className="left-part">
                  <InfiniteScroll
                    dataLength={items.length} //This is important field to render the next data
                    //next={this.props.get_list_object.bind(this.props.sessionId,node.endpoint,node,false,this.props.pageNumber,false)}
                    next={this.props.getDataSet.bind(this,node,false,this.state.term)}
                    hasMore={true}
                    loader={null}
                    endMessage={
                      <p style={{ textAlign: 'center' }}>
                        <b>Yay! You have seen it all</b>
                      </p>
                    }
                  >
                  <table>
                    {buildHeader}
                    {buildList}
                  </table>
                  </InfiniteScroll>
                </div>
                <div className={this.state.rightIsOpen?"right-part active":"right-part"}>
                  <div className="part-header">
                    <div className="title">Detailed View</div>
                    <div className="actions"><span onClick={this.closeRightPart.bind()}><FontAwesomeIcon icon="times"/></span></div>
                    <div className="mode">
                      <div className="item-action"><FontAwesomeIcon  icon="trash" /></div>
                    </div>
                  </div>
                  <div className="content"></div>
                </div>
              </div>
              
          </div>
      );
  }
}

const mapStateToProps = (state) => {    
  return {  
    language: state.appReducer.language,
    sessionId: state.apiReducer.sessionId,
    pageNumber:state.apiReducer.pageNumber,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    get_list_object: (sessionId,endPoint,node,options,page) =>dispatch(repositoryActions.get_list_object(sessionId,endPoint,node,options,page)),
    resetPagination: () => dispatch(repositoryActions.resetPagination()),
    loadMore:(lastRequest)=>dispatch(repositoryActions.loadMore(lastRequest)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(ListView);
  